
import { AppVars } from "./types/app";
const vars = window.vars as AppVars;
export default vars;
